import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import AppLayout from '@/containers/layouts/appLayout'
import login from '@/containers/login'
import index from '@/containers/index'
import wellcome from '@/components/wellcome/wellcome'
import myCourses from '@/components/courses/myCourses/myCourses'

export const routerMap = [

  {
    path: '/',
    name: 'login',
    component: login,
  },
  {
    path: '/inicio',
    name: 'index',
    component: AppLayout,
    children: [
      {
        path: 'Menu',
        name: 'menu',
        component: index,
        children: [
          {
            path: '/Programa/:id',
            name: 'Program',
            component: () => import('@/containers/programa'),
            meta: { title: 'Programa' },
          },
          {
            path: 'Bienvenido',
            name: 'wellcome',
            component: wellcome,
          },
          {
            path: 'Mis-cursos',
            name: 'myCourses',
            component: myCourses,
          },
          {
            path: 'Certificados',
            name: 'certificates',
            component: () => import('@/components/certificate/certificate'),
          },
          {
            path: 'Home',
            name: 'AdminHome',
            component: () => import('@/containers/admin'), 
          },
          {
            path: 'Ranking',
            name: 'ranking',
            component: () => import('@/components/ranking/ranking'), 
          },
          {
            path: 'Plan-de-Estudio',
            name: 'studyPlan',
            component: () => import('@/components/studyPlan/studyPlan'), 
          },
          {
            path: 'Administrador-Dashboard',
            name: 'adminDashboard',
            component: () => import('@/components/adminDashboard/adminDashboard'), 
          },
          {
            path: 'SuperAdministrador-Dashboard',
            name: 'superAdminDashboard',
            component: () => import('@/components/superAdminDashboard/adminDashboard'), 
          },
          {
            path: 'Matriz-de-Capacitacion',
            name: 'matriz',
            component: () => import('@/components/matriz/matriz'), 
          },
          {
            path: 'Asignar-Cursos',
            name: 'assign',
            component: () => import('@/components/matriz/assign'), 
          },
          {
            path: 'Nueva-Pregunta/:lectureId',
            name: 'AddQuestion',
            component: () => import('@/components/admin/questions/addQuestion'), 
          },
          {
            path: 'Nuevo-Curso',
            name: 'AddCourse',
            component: () => import('@/components/admin/courses/addCourse'), 
          },
          {
            path: 'Certificado/:courseId',
            name: 'Certificate',
            component: () => import('@/components/courses/course/certificate'), 
          },
          {
            path: 'Reprobado',
            name: 'testReproved',
            component: () => import('@/components/courses/course/fail'), 
          },
          {
            path: 'Estadisticas',
            name: 'Dashboard',
            component: () => import('@/components/dashboard/dashboard'), 
          },
          
          {
            path: 'Editar-Curso/:id',
            name: 'EditCourse',
            component: () => import('@/components/admin/courses/editCourse'), 
          },
          {
            path: 'Editar-Datos-Curso/:id',
            name: 'viewEditCourse',
            component: () => import('@/components/admin/courses/viewEditCourse'), 
          },
          {
            path: 'Editar-Pregunta/:lectureId&:name',
            name: 'EditQuestion',
            component: () => import('@/components/admin/questions/editQuestion'), 
          },
          
          {
            path: 'Agragar-Clase/:moduleId',
            name: 'AddClass',
            component: () => import('@/components/admin/lectures/addClass'), 
            children: [
              {
                path: 'Video',
                name: 'tipoVideo',
                component: () => import('@/components/admin/lectures/tipoVideo'), 
              },
              {
                path: 'Presentacion',
                name: 'tipoPresentacion',
                component: () => import('@/components/admin/lectures/tipoPresentacion'), 
              },
              {
                path: 'Test',
                name: 'tipoTest',
                component: () => import('@/components/admin/lectures/tipoTest'), 
              }
            ]
          },
          {
            path: 'editar-Clase/:classId',
            name: 'EditClass',
            component: () => import('@/components/admin/lectures/editClass'), 
            children: [
              {
                path: 'Video',
                name: 'EditTipoVideo',
                component: () => import('@/components/admin/lectures/tipoVideo'), 
              },
              {
                path: 'Presentacion',
                name: 'EditTipoPresentacion',
                component: () => import('@/components/admin/lectures/tipoPresentacion'), 
              },
              {
                path: 'Test',
                name: 'EditTipoTest',
                component: () => import('@/components/admin/lectures/tipoTest'), 
              }
            ]
          }
        ]
      },
    ]
  },
  {
    path: '/Mis-cursos',
    component: AppLayout,
    name: 'Courses',
    children: [
      {
        path: '/perfil',
        name: 'Perfil',
        component: () => import('@/containers/perfil'),
      },
      {
        path: 'Curso',
        name: 'Course',
        component: () => import('@/containers/course'),
        meta: { title: 'Curso' },
        children: [
          {
            path: 'Contenido',
            name: 'ContainerLec',
            component: () => import('@/components/courses/course/lecture'),
            children: [
                {
                  path: 'Clase/:lectureId&:courseId',
                  name: 'Lecture',
                  component: () => import('@/components/courses/course/containerLecture'),
                },
                {
                  path: 'Resultado/:lectureId&:score&:courseId',
                  name: 'testFinal',
                  component: () => import('@/components/courses/course/testFinal'), 
                },
                {
                  path: 'Fallido/:lectureId',
                  name: 'TestFail',
                  component: () => import('@/components/courses/course/testFail'), 
                },
               
              
            ]
          }
          
        ]
      } 
    ]
  }, 
]

export default new Router({
  routes: routerMap,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js